import * as types from '../types/websiteContextTypes';
import apiConfig from '../../config/apiConfig';

const initialState = {
  slug: apiConfig.WEBSITE_SLUG,
};

const websiteContextReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_WEBSITE_SLUG:
      return { ...state, slug: action.payload };
    case types.RESET_WEBSITE_SLUG:
      return { ...state, slug: apiConfig.WEBSITE_SLUG };
    default:
      return state;
  }
};

export default websiteContextReducer;

